module.exports = __webpack_public_path__ + "img/icon-factory.07c4d3eb.svg";